export default __webpack_public_path__ + "static/media/Dislike.d124b94d.svg";